export const gridTemplate = (columns: number) =>
  `repeat(${Math.max(1, columns)}, minmax(0, 1fr))`;

export const gapCss = ($gap?: string | number) => {
  if ($gap === undefined || $gap === null) {
    return "1rem";
  }
  return typeof $gap === "number" ? `${$gap}px` : $gap;
};
